import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';

@Component({
  selector: 'lib-perio-exam-intro',
  standalone: true,
  imports: [TranslatePipe, SvgIconComponent],
  templateUrl: './perio-exam-intro.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioExamIntroComponent {}
